import React from 'react'

/*
 * One animated vector per public page, sitting in the shared masthead.
 * Self-contained SVG; the motion classes live in PageShell.scss.
 */

const Frame = ({ label, children }) => (
    <svg className="ha" viewBox="0 0 320 236" role="img" aria-label={label}>{children}</svg>
);

/* About — six scattered places collapsing into one */
export const AboutArt = () => (
    <Frame label="Scattered tools converging into one place">
        <path className="ha-flow ha-f1" d="M70 58 L132 100" />
        <path className="ha-flow ha-f2" d="M252 54 L190 100" />
        <path className="ha-flow ha-f3" d="M68 182 L132 140" />
        <path className="ha-flow ha-f4" d="M250 184 L190 140" />

        <g className="ha-chip ha-c1">
            <rect x="26" y="42" width="88" height="32" rx="16" />
            <circle cx="44" cy="58" r="5" />
            <rect x="58" y="54" width="42" height="7" rx="3.5" />
        </g>
        <g className="ha-chip ha-c2">
            <rect x="206" y="38" width="90" height="32" rx="16" />
            <circle cx="224" cy="54" r="5" />
            <rect x="238" y="50" width="44" height="7" rx="3.5" />
        </g>
        <g className="ha-chip ha-c3">
            <rect x="24" y="166" width="88" height="32" rx="16" />
            <circle cx="42" cy="182" r="5" />
            <rect x="56" y="178" width="42" height="7" rx="3.5" />
        </g>
        <g className="ha-chip ha-c4">
            <rect x="204" y="168" width="92" height="32" rx="16" />
            <circle cx="222" cy="184" r="5" />
            <rect x="236" y="180" width="46" height="7" rx="3.5" />
        </g>

        <circle className="ha-ring" cx="160" cy="118" r="62" />
        <rect className="ha-card" x="108" y="88" width="104" height="60" rx="20" />
        <circle className="ha-dot" cx="132" cy="112" r="9" />
        <rect className="ha-line" x="149" y="107" width="44" height="8" rx="4" />
        <rect className="ha-line ha-line--faint" x="149" y="121" width="28" height="7" rx="3.5" />
        <rect className="ha-bar" x="124" y="130" width="72" height="6" rx="3" />
    </Frame>
);

/* Plans — three tiers, the middle one carrying the badge */
export const PlansArt = () => (
    <Frame label="Three pricing tiers, the middle one recommended">
        <rect className="ha-base" x="34" y="196" width="252" height="6" rx="3" />

        <rect className="ha-col ha-col-1" x="52" y="128" width="60" height="66" rx="20" />
        <rect className="ha-col ha-col-2 is-lead" x="130" y="82" width="60" height="112" rx="20" />
        <rect className="ha-col ha-col-3" x="208" y="106" width="60" height="88" rx="20" />

        <rect className="ha-line ha-line--faint ha-tag ha-t1" x="64" y="146" width="36" height="7" rx="3.5" />
        <rect className="ha-line ha-tag ha-t2" x="142" y="100" width="36" height="8" rx="4" />
        <rect className="ha-line ha-line--faint ha-tag ha-t3" x="220" y="124" width="36" height="7" rx="3.5" />

        <g className="ha-badge">
            <circle className="ha-badge-disc" cx="160" cy="54" r="24" />
            <path className="ha-tick" d="M150 54.5 L157 61.5 L171 47" />
        </g>
    </Frame>
);

/* Contact — a message sent, an answer coming back */
export const ContactArt = () => (
    <Frame label="A message sent and answered">
        <g className="ha-bubble">
            <rect className="ha-card" x="26" y="34" width="130" height="56" rx="20" />
            <circle className="ha-dot ha-d1" cx="60" cy="62" r="6" />
            <circle className="ha-dot ha-d2" cx="82" cy="62" r="6" />
            <circle className="ha-dot ha-d3" cx="104" cy="62" r="6" />
        </g>

        <path className="ha-trail" d="M188 74 C214 66 244 74 262 96" />
        <g className="ha-plane">
            <path className="ha-plane-body" d="M254 78 L286 92 L256 104 L252 94 Z" />
        </g>

        <rect className="ha-envelope-back" x="60" y="118" width="200" height="96" rx="22" />
        <g className="ha-slip">
            <rect className="ha-card" x="92" y="96" width="136" height="70" rx="16" />
            <rect className="ha-line" x="110" y="116" width="70" height="8" rx="4" />
            <rect className="ha-line ha-line--faint" x="110" y="132" width="46" height="7" rx="3.5" />
        </g>
        <path className="ha-envelope-front" d="M60 148 L160 202 L260 148 L260 192 a22 22 0 0 1 -22 22 H82 a22 22 0 0 1 -22 -22 Z" />
    </Frame>
);
